import { WhatsApp } from "@whatsper/texterchat-common";
/**
 * Build the `buttons` components for a single-recipient template send.
 *
 * Only buttons carrying runtime data are sent: a URL button with a filled-in `{{n}}` parameter,
 * a quick-reply payload, or a flow token. Static call-to-action buttons (static URL / PHONE_NUMBER)
 * are baked into the approved template and render automatically — sending a component for them is
 * rejected by the server schema (`buttons/0 must NOT have additional properties`), so they are omitted.
 */
export function buildTemplateSendButtons(buttons, urlTemporaryParams) {
    const requestButtons = [];
    buttons.forEach((button) => {
        if (button.type === WhatsApp.TemplateButtonType.URL && button.url) {
            const placeholderMatch = button.url.match(/{{(\d+)}}/);
            if (placeholderMatch) {
                const placeholderNum = parseInt(placeholderMatch[1]);
                const urlParameter = urlTemporaryParams[placeholderNum - 1] || '';
                // Only send the URL button when its parameter is filled; otherwise omit it.
                if (urlParameter.trim() !== '') {
                    requestButtons.push({
                        type: WhatsApp.TemplateButtonType.URL,
                        text: button.text,
                        payload: urlParameter.trim(),
                    });
                }
            }
        }
        else if (button.type === WhatsApp.TemplateButtonType.QUICK_REPLY) {
            requestButtons.push({
                type: WhatsApp.TemplateButtonType.QUICK_REPLY,
                text: button.text,
                payload: button.payload || button.text,
            });
        }
        else if (button.type === WhatsApp.TemplateButtonType.FLOW) {
            requestButtons.push({
                type: WhatsApp.TemplateButtonType.FLOW,
                text: button.text,
                flow_token: button.flow_id || button.flow_json || button.flow_token,
                flow_action_data: button.flow_action_data,
            });
        }
        // Static PHONE_NUMBER and static URL buttons carry no runtime data and are omitted.
    });
    return requestButtons;
}
